import { render, staticRenderFns } from "./LabelInput.vue?vue&type=template&id=66ca513b"
import script from "./LabelInput.vue?vue&type=script&lang=js"
export * from "./LabelInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports